(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sticky-side-widget"] && !Shopify.designMode) return;
  try {
    function waitForElement(selector, callback) {
      var poops = setInterval(function () {
          if (document.querySelector(selector)) {
              clearInterval(poops);
              callback();
          }
      }, 100);
  }
  

  document.addEventListener("DOMContentLoaded", () => {
    // Create the side widget container
    const sideWidget = document.querySelector(".CP-side-widget");

    // Check if the size chart is present to conditionally add size chart button
    const isSizeChart = !!document.querySelector(".tw-size-chart");
    const sizeChartEvent = document.querySelector(".tw-size-chart")?.getAttribute("onclick");


    /**** Recently Viewed Drawer **/
      // Handler for Recently Viewed button click
      const recentBtn = sideWidget.querySelector(".CP-recently-viewed");
      if (recentBtn) {
        recentBtn.addEventListener("click", () => {
          document.documentElement.classList.add("CP-rv-open");
          const drawer = document.querySelector(".CP-recentlyViewedDrawer");
          if (!drawer) return;
          const itemsContainer = drawer.querySelector(".CP-items");
          if (!itemsContainer) return;
          itemsContainer.innerHTML = "";

          // Get recently viewed from localStorage or empty array
          const recent = JSON.parse(localStorage.getItem("cp_IT_recentlyViewed") || "[]");

          // Get current product slug from URL
          const currentSlug = window.location.pathname.split("/products/")[1]?.split("/")[0] || "";

          // Filter out current product
          const filteredRecent = recent.filter(item => item.slug !== currentSlug);

          filteredRecent.forEach((item) => {
            // Prepare product data for Quick View button
            const productData = {
              id: item.id || "",
              title: item.title,
              type: item.type || "",
              images: item.images || [item.image],
              variants: item.variants || [
                {
                  price: parseFloat(item.price.replace(/[^0-9.]/g, "")) * 100 || 0,
                },
              ],
              url: `/products/${item.slug}`,
            };

            // Create a product card HTML string
            const productCard = `
              <div class="CP-drawer-product-card">
                <div class="CP-drawer-product-media" key="${item.slug}">
                  <div class="CP-drawer-slide">
                    <img src="${item.image.replace(/(\.(jpg|jpeg|png|webp))/, "_480x$1")}" alt="${item.title || ''}" />
                  </div>
                </div>
                <div class="CP-drawer-product-info">
                  <h2>${item.title}</h2>
                  <div class="CP-drawer-price-info">
                    <span class="money" doubly-currency="INR">${item.price}</span>
                  </div>
                </div>
                <div class="CP-drawer-action-btn">
                  <button class="quick-view" data-product='${JSON.stringify(productData).replace(/'/g, "&#39;")}'>
                    Quick View
                  </button>
                </div>
              </div>
            `;
            itemsContainer.insertAdjacentHTML("beforeend", productCard);
          });

          // Check chip visibility AFTER cards are added
          const chipIcon = document.querySelector(".CP-chip-item.CP-recently-viewed");
          if (chipIcon) {
            const cardCount = itemsContainer.querySelectorAll(".CP-drawer-product-card").length;
            chipIcon.style.display = cardCount > 1 ? "inline-flex" : "none";
          }

          // Open drawer overlay and drawer panel
          drawer.classList.add("open");
          document.querySelector(".drawer-overlay").style.display = "block";
        });
      }
      
      // If there is a Size Chart button, bind click to trigger the respective function
      if (isSizeChart && sizeChartEvent) {
          const functionName = sizeChartEvent.split("(")[0];
          const sizeChartBtn = sideWidget.querySelector(".CP-size-chart");
          if (sizeChartBtn && typeof window[functionName] === "function") {
          sizeChartBtn.addEventListener("click", () => {
              window[functionName]();
          });
          }
      }

    /**** Similar Products ****/
      // Create overlay if not already present
      let overlay = document.querySelector(".CP-Similar_overlay");
      if (!overlay) {
          overlay = document.createElement("div");
          overlay.className = "CP-Similar_overlay";
          document.body.appendChild(overlay);
      }
      // Get drawer element, create if it doesn't exist
      let drawer = document.querySelector(".CP-Similar_Drawer");
      // Close drawer function
      const closeDrawer = () => {
          document.body.classList.remove("no-scroll");
          drawer.classList.remove("open");
          overlay.style.display = "none";
      };
      // ATC click
      function attachAtcListeners() {
          const clonedButtons = document.querySelectorAll(
          ".CP-Similar_Drawer .CP-Similar_items .card-product_atcModal"
          );
          clonedButtons.forEach((btn, index) => {
              btn.addEventListener("click", () => {
                  const originalProducts = document.querySelectorAll(
                  "#similar-products > .product.recentproduct .card-product_atcModal"
                  );
                  if (originalProducts[index]) {
                      originalProducts[index].click();
                  }
                  document.body.classList.remove("no-scroll");
                  document.querySelector(".CP-Similar_Drawer").classList.remove("open");
                  document.querySelector(".CP-Similar_overlay").style.display =
                  "none";
              });
          });
      }
      attachAtcListeners();
      // Attach close event handlers
      const closeBtn = drawer.querySelector(".CP-Similar_closeDrawerBtn");
      if (closeBtn) {
        closeBtn.addEventListener("click", closeDrawer);
      }
      overlay.addEventListener("click", closeDrawer);
      // Setup event to open drawer when .CP-similar-product is clicked
      const similarProductBtn = document.querySelector(".CP-chip-item.CP-similar-product");
      if (similarProductBtn) {
          similarProductBtn.addEventListener("click", () => {
              document.body.classList.add("no-scroll");
              drawer.classList.add("open");
              overlay.style.display = "block";
              appendProducts();
          });
      }

      /******/
      // Safely remove the element if it exists
      const sizeChartToRemove = document.querySelector('.custom-sidebar + .sizeChartSidebar');
      if (sizeChartToRemove) {
          sizeChartToRemove.remove();
      }
      /******/
      // Handle toggle of CP-sizeChartSidebar
      const sizeChartSidebar = document.querySelector(".sizeChartSidebar.CP-sizeChartSidebar");
      const sizeChartBtn = document.querySelector(".CP-chip-item.CP-size-chart");
      const sizeChartOverlay = document.querySelector(".CP_IT_PDP_18_V1 .bg_opacity");
      const sizeChartCloseBtn =
        (sizeChartSidebar && sizeChartSidebar.querySelector(".cp-custom_close")) ||
        (sizeChartSidebar && sizeChartSidebar.querySelector(".cp-sizeChartClose"));

      if (sizeChartSidebar && sizeChartBtn) {
        sizeChartBtn.addEventListener("click", () => {
          sizeChartSidebar.classList.toggle("sidenav-open");
          sizeChartSidebar.classList.remove("sidenav");
          sizeChartOverlay.classList.add("show_opacity");
          document.body.classList.add("removeScroll"); //  add scroll lock on body
        });
      }
      if (sizeChartSidebar && sizeChartCloseBtn) {
        sizeChartCloseBtn.addEventListener("click", () => {
          sizeChartSidebar.classList.remove("sidenav-open");
          sizeChartSidebar.classList.remove("sidenav");
          sizeChartOverlay.classList.remove("show_opacity");
          document.body.classList.remove("removeScroll"); //  remove scroll lock from body
          document.querySelector("html").style.overflowY = 'unset';
        });
      }
      if (sizeChartSidebar && sizeChartOverlay) {
        sizeChartOverlay.addEventListener("click", () => {
          sizeChartSidebar.classList.remove("sidenav-open");
          sizeChartSidebar.classList.remove("sidenav");
          sizeChartOverlay.classList.remove("show_opacity");
          document.body.classList.remove("removeScroll"); //  remove scroll lock from body
        });
      }
      document.querySelectorAll(".CP-sizeChartSidebar label.customRadio.customedRadio").forEach(label => {
        label.addEventListener("click", function () {
          document.querySelectorAll("label.customRadio.customedRadio").forEach(l => {
            l.classList.remove("activeRadio");
          });
          this.classList.add("activeRadio");
        });
      });


    /****  ****/
    // 1. Get references for product detail container and breadcrumb
    var productDetails = document.querySelector(".CP-inner_content");
    var breadcrumb = document.querySelector(".produt-breadcrum_cont a.product-breadcrum_sub.product-breadcrum_sub-col");
    if (!productDetails || !breadcrumb) return;
    var breadcrumbText = breadcrumb.textContent ? breadcrumb.textContent.trim() : "";
    var breadcrumbHref = breadcrumb.getAttribute("href") || "";
    if (!breadcrumbHref || !breadcrumbText) return;
    // Collect collections info from window.productCollections if present
    var allCollections = [];
    if (window.productCollections && Array.isArray(window.productCollections)) {
      allCollections = window.productCollections.slice();
    }
    allCollections.push({ url: breadcrumbHref, title: breadcrumbText });
    allCollections.reverse(); // Most recent collection first
    // Normalize helper
    function normalize(str) {
      return (str || "").toLowerCase().replace(/\s+/g, "-").replace(/[^a-z0-9-]/g, "");
    }
    // Get product slug from URL
    function getProductSlug(path) {
      if (!path || typeof path !== "string") return null;
      var match = path.match(/\/products\/([^0-9]+)/);
      if (!match) return null;
      return match[1].replace(/-+$/, "").trim();
    }
    // Get clean collection slug from URL
    function getCleanCollectionSlug(url) {
      if (!url || typeof url !== "string") return "";
      return url.replace(/^\/collections\//, "").trim();
    }
    // Find the closest collection match
    function findClosestCollectionFromSlug(collections) {
      var productSlug = getProductSlug(window.location.pathname || "");
      if (!productSlug) return null;
      var prodType = normalize(window.meta && window.meta.product ? window.meta.product.type : "");
      var closest = null;
      var highestScore = -1;
      collections.forEach(function (col) {
        if (!col || !col.url) return;
        var colSlug = normalize(getCleanCollectionSlug(col.url));
        var colTitle = normalize(col.title);
        var score = 0;

        if (prodType && (colSlug.includes(prodType) || colTitle.includes(prodType))) score += 1;
        productSlug.split("-").forEach(function (word) {
          if (word && (colSlug.includes(word) || colTitle.includes(word))) score += 1;
        });
        if (
          prodType &&
          (colSlug.includes(prodType) || colTitle.includes(prodType)) &&
          productSlug
            .split("-")
            .some(function (w) {
              return w && w !== prodType && (colSlug.includes(w) || colTitle.includes(w));
            })
        ) {
          score += 1;
        }
        if (score > highestScore) {
          highestScore = score;
          closest = col;
        }
      });
      return closest;
    }
    // Find best collection match
    var bestMatch = findClosestCollectionFromSlug(allCollections);
    // Use matched collection or fallback to breadcrumb
    var finalHref = (bestMatch && bestMatch.url) || breadcrumbHref;
    var finalLabel = "Check more " + ((bestMatch && bestMatch.title) || breadcrumbText);
    // Build and insert the button
    var checkMoreButton = '<a href="' + finalHref + '" class="CP-check-more-button">' + finalLabel + '</a>';
    productDetails.insertAdjacentHTML("afterend", checkMoreButton);
    
  });

  

  waitForElement('custom-quantity-input.cart-quantity', function () { 

    const customQuantityWrapper = document.querySelector("custom-quantity-input.cart-quantity");
    const quantityInput = customQuantityWrapper ? customQuantityWrapper.querySelector("input.quantity__input") : null;

    if (!customQuantityWrapper || !quantityInput) {
        return; // required elements not found
    }

    // Get current quantity value, fallback to 1 if invalid
    const currentValue = parseInt(quantityInput.value, 10) || 1;

    // Create the custom select dropdown
    const select = document.createElement("select");
    select.className = "custom-quantity-select";
    select.setAttribute("aria-label", "Select quantity");

    // Add options 1 to 10
    for (let i = 1; i <= 10; i++) {
        const option = document.createElement("option");
        option.value = i;
        option.textContent = i;
        if (i === currentValue) option.selected = true;
        select.appendChild(option);
    }

    // Insert the dropdown before the original input
    customQuantityWrapper.parentNode.insertBefore(select, customQuantityWrapper);

    // Sync select changes to the original input
    select.addEventListener("change", function (e) {
        quantityInput.value = e.target.value;
        // Dispatch change event on the original input to notify any listeners
        const event = new Event("change", { bubbles: true });
        quantityInput.dispatchEvent(event);
    });

  });




  document.addEventListener("DOMContentLoaded", function () {
    // Query all relevant elements immediately
    var variantRadios = document.querySelector("variant-radios");
    var atcContainer = document.querySelector(".CP-atc-qty-container");
    var atcButton = document.querySelector(".ito_atc__button");
    var toggleArrow = document.querySelector(".CP-toggle-arrow");
    var qtyContainer = document.querySelector(".qty-container");
    var priceText = document.querySelector(".CP-atc-price");

    var atcClickCount = 0;
    var radioInputs = [];
    var qtyLabel;

    if (variantRadios) {
      var fieldset = variantRadios.querySelector("fieldset");
      radioInputs = fieldset.querySelectorAll('input[type="radio"][name="Size"]');
      var purchaseButtons = document.querySelector(".purchase-details__buttons");
      qtyLabel = variantRadios.querySelector(".qty-label-size");
      qtyLabel.innerHTML = "select Size :";

      if (!radioInputs.length || !purchaseButtons) return;

      radioInputs.forEach(function (input) {
        input.checked = false;
      });

      var selectSize = document.createElement("select");
      selectSize.className = "custom-size-dropdown";
      selectSize.setAttribute("aria-label", "Select Size");

      var placeholderOption = document.createElement("option");
      placeholderOption.textContent = "Select Size";
      placeholderOption.disabled = true;
      placeholderOption.selected = true;
      placeholderOption.value = "";
      selectSize.appendChild(placeholderOption);

      radioInputs.forEach(function (input) {
        var label = fieldset.querySelector('label[for="' + input.id + '"]');
        var sizeValue = input.value;
        var option = document.createElement("option");
        option.value = sizeValue;
        option.textContent = label ? label.innerText.trim() : sizeValue;
        selectSize.appendChild(option);
      });

      purchaseButtons.insertAdjacentElement("afterend", selectSize);

      function showSizeError() {
        qtyLabel.classList.add("CP-error-msg");
        var labels = variantRadios.querySelectorAll("label");
        labels.forEach(function (label) {
          label.classList.add("CP-error");
        });
        qtyLabel.innerHTML = "Please Select Size";
        qtyLabel.scrollIntoView({ behavior: "smooth", block: "center" });
      }

      function clearSizeError(selectedSize) {
        qtyLabel.classList.remove("CP-error-msg");
        var labels = variantRadios.querySelectorAll("label");
        labels.forEach(function (label) {
          label.classList.remove("CP-error");
        });
        qtyLabel.innerHTML = "Select Size: " + selectedSize;
      }

      selectSize.addEventListener("change", function (e) {
        var selectedSize = e.target.value;
        radioInputs.forEach(function (input) {
          if (input.value === selectedSize) {
            input.click();
            if (typeof window.appendCheckedSizeToLegend === "function") {
              window.appendCheckedSizeToLegend();
            }
          }
        });
        if (selectedSize) {
          clearSizeError(selectedSize);
        }
      });

      radioInputs.forEach(function (input) {
        input.addEventListener("change", function () {
          if (input.checked) {
            selectSize.value = input.value;
            clearSizeError(input.value);
          }
        });
      });
    }

    // Mobile-only ATC behavior
    if (window.matchMedia("(max-width: 768px)").matches) {
      ["click", "touchend"].forEach(function (eventType) {
        if (!atcButton) return;
        atcButton.addEventListener(
          eventType,
          function (e) {
            var isSticky =
              atcContainer && atcContainer.classList.contains("cp_sticky");
            if (isSticky && atcClickCount === 0) {
              e.preventDefault();
              if (typeof e.stopImmediatePropagation === "function")
                e.stopImmediatePropagation();

              if (toggleArrow) {
                toggleArrow.classList.add("active");
                toggleArrow.classList.remove("hidden");
              }
              if (qtyContainer) {
                qtyContainer.classList.remove("hidden");
              }

              atcClickCount++;
              return;
            }

            var selected =
              radioInputs.length > 0
                ? Array.from(radioInputs).some(function (input) {
                    return input.checked;
                  })
                : true;
            if (variantRadios && !selected) {
              e.preventDefault();
              if (typeof e.stopImmediatePropagation === "function")
                e.stopImmediatePropagation();
              if (qtyLabel) showSizeError();
              return;
            }

            if (priceText) {
              priceText.style.visibility = "hidden";
              setTimeout(function () {
                priceText.style.visibility = "visible";
                if (variantRadios) {
                  var url = new URL(window.location.href);
                  url.searchParams.delete("variant");
                  window.history.replaceState(null, "", url.toString());

                  radioInputs.forEach(function (input) {
                    input.checked = false;
                  });

                  var sizeSelect = document.querySelector(
                    ".custom-size-dropdown"
                  );
                  if (sizeSelect) sizeSelect.value = "";

                  var quantitySelect = document.querySelector(
                    ".custom-quantity-select"
                  );
                  if (quantitySelect) quantitySelect.value = "1";

                  var qtyLabelEl =
                    variantRadios.querySelector(".qty-label-size");
                  if (qtyLabelEl) qtyLabelEl.innerHTML = "select Size :";
                }
              }, 2000);
            }
          },
          { passive: false }
        );
      });

      // Toggle arrow also only on mobile
      if (toggleArrow) {
        toggleArrow.addEventListener("click", () => {
          toggleArrow.classList.toggle("active");
          if (qtyContainer) qtyContainer.classList.toggle("hidden");
        });
      }
    }
  });

  

             
  // Current Currency Sign
  document.addEventListener("click", function (e) {   
    if( e.target.closest('.footer select.currency-switcher') ) {
      const currentCurrencySign = e.target.closest('.footer select.currency-switcher');
      let curntCurnySignVal = "";
      // initial value
      curntCurnySignVal = currentCurrencySign.value;
      // update on change
      currentCurrencySign.addEventListener("change", (e) => {
        curntCurnySignVal = e.target.value;
        console.log("Currency changed:", curntCurnySignVal);
      });
      console.log(e.target.closest('.footer select.currency-switcher').value);

      document.querySelectorAll(".CP-recentlyViewedDrawer .CP-drawer-price-info > span").forEach((el, index) => {
        el.setAttribute("doubly-currency", curntCurnySignVal);
      });
    }

  });


  /**** STICKY ****/
  document.addEventListener("DOMContentLoaded", function () {
    const custom_qty_atc_Container = document.querySelector(".CP-atc-qty-container");
    const customTextContainer = document.querySelector(".qty-label-cont");
    if (!custom_qty_atc_Container || !customTextContainer) return;
    function checkVisibility() {
      const rect = customTextContainer.getBoundingClientRect();
      const offset = -73;
      const inView =
        rect.top >= 0 + offset &&
        rect.bottom <= window.innerHeight;

      if (inView) {
        custom_qty_atc_Container.classList.remove("cp_sticky");
      } else {
        custom_qty_atc_Container.classList.add("cp_sticky");
      }
    }
    // Run on load and on scroll
    checkVisibility();
    window.addEventListener("scroll", checkVisibility, { passive: true });
    window.addEventListener("resize", checkVisibility); // keep responsive
  });
  } catch(e) { console.error(e); }
})();

})();
